import { useCheckLoadedAndShow } from '../hooks/useCheckLoadedAndShow';
export function useUltipro() {
    useCheckLoadedAndShow();
}
